/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'present': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M34 24v2h-9v8c0 .553-.672 1-1.5 1s-1.5-.447-1.5-1v-8h-8v-2h20zm-2-10H17.5c0-2.231.436-3.64 1.228-3.968.537-.222 1.324.031 2.162.663l-.304.305 1.914 1.914 1.414-1.414L22 9.586l-.399.398c-1.184-.93-2.339-1.257-3.255-.876C17.121 9.615 16.5 11.262 16.5 14H16l-1.5 9h19L32 14z"/><path pid="1" d="M25 30.154V34c0 .553-.672 1-1.5 1s-1.5-.447-1.5-1v-3.846c-2.308.476-4 2.016-4 3.846 0 2.209 2.463 4 5.5 4s5.5-1.791 5.5-4c0-1.83-1.692-3.37-4-3.846z" opacity=".5"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/present.js